export const parseToObject = <T = unknown>(prop: T | string): T => {
  return typeof prop === 'string' ? (JSON.parse(prop) as T) : prop;
};

export const parseToArray = <T = unknown>(prop: string | T[]): T[] => {
  if (!prop) return [];

  return Array.isArray(prop) ? prop : Array.from(JSON.parse(prop) as T[]);
};

const parser = new DOMParser();
export function parseHtml(html = '', type: DOMParserSupportedType = 'text/html', getBody = false) {
  const parsed = parser.parseFromString(html, type).body;

  return getBody ? parsed : (parsed.firstChild as HTMLElement);
}
